import { render, staticRenderFns } from "./AvisoDetailView.vue?vue&type=template&id=76d9f39e&"
import script from "./AvisoDetailView.vue?vue&type=script&lang=js&"
export * from "./AvisoDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports